import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from './Item'

export function GoodToKnow() {
  const info = useCMSPageField('PDP.attention')
  const intl = useIntl()

  if (info === '')
    return null

  return (
    <Item elementDL="Good to know" title={intl.formatMessage({ id: 'practical_info_good_to_know_title' })} Glyph="InformationInCircle">
      <RichText innerHTML={info} />
    </Item>
  )
}
